<template>
    <div class="page-class"
        :class="{'farmer': userType == 'farmer', 'subdist': userType == 'subdist', 'dist': userType == 'dist', 'sale': userType == 'sale'}">
        <div class="page-wrapper">
            <div id="horoscope" class="page-content"
                v-if="isAccountLoaded">
                <nav-bar
                    :pageName="lbl.horoscope.title"
                    :userType="userType"
                    @clickBack="clickBack"></nav-bar>
                <div id="horoscope_content" v-html="detail"></div>
            </div>

            <div class="page-bg"></div>
            <!-- <cookie-consent-bar></cookie-consent-bar> -->
        </div>
    </div>
</template>
<script>
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
//component
import NavBar from "@/components/Layout/NavBar/NavBar.vue";
// import CookieConsentBar from '@/components/Layout/CookieConsentBar/CookieConsentBar.vue';
//service
import BlobService from '@/core/BlobService/service/BlobService.js';

export default {
    name: 'Horoscope',
    mixins: [AccountMixin, LocaleMixin],
    components: {
        NavBar,
        // CookieConsentBar,
    },
    computed: {
        userType: function () {
            return this.$store.state.userType;
        }
    },
    data: function () {
        return {
            horoscope: null,
            category: null,
            campaignId: null,
            detail: null,
        };
    },
    created: async function () {
        this.campaignId = this.$route.params.campaignId;
        await this.getBlobConfig();

        this.getHoroscopeContent();

    },
    methods: {
        getBlobConfig: function(){
            return new Promise((resolve) => {
                BlobService.getHoroscopeConfig()
                    .then(res => {
                        console.log('horo', res.data);
                        this.category = res.data.category;
                        this.horoscope = res.data.horoscope;

                        resolve(res.data);
                    }).catch(err => {
                        console.log(err);
                        resolve(null);
                    });
            })
        },
        getHoroscopeContent: function(){
            this.horoscope.filter((item) =>{
                if(item.id == this.campaignId){
                    console.log('item.id', item.id);
                    console.log('this.campaignId', this.campaignId);
                    console.log('item', item.content);
                    this.detail = item.content;
                }
            });

            console.log('this.detail', this.detail)
        },
        clickBack: function(){
            this.$router.back();
        }
    }
}
</script>
<style lang="scss">
@import "@/style/base/common.scss";
#horoscope{
    .nv-name{
        line-height: 1;
    }
}
#horoscope_content {
    width: 100%;
    padding: 20px 15px;
    margin-bottom: 20px;
}
</style>
